import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadPostbackSettingsRequest } from '../../actions/loadPostbackSettings';
import { getLoadPostbackSettingsError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadPostbackSettingsHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadPostbackSettingsRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadPostbackSettingsError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadPostbackSettingsHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
